import {
  getAnalytics,
  isSupported,
  logEvent,
  setUserId,
} from 'firebase/analytics';
import { app } from '../firebase';

let analytics = null;

// isSupported guards environments without analytics (some in-app browsers,
// cookies disabled, etc.) so tracking silently no-ops instead of throwing.
isSupported()
  .then((ok) => {
    if (ok) analytics = getAnalytics(app);
  })
  .catch(() => {});

/** Log an analytics event; safe to call anywhere (no-ops when unavailable). */
export function track(name, params) {
  if (analytics) logEvent(analytics, name, params);
}

/** Associate events with the signed-in user (pass null on sign-out). */
export function setAnalyticsUser(uid) {
  if (analytics) setUserId(analytics, uid || null);
}
